module.exports = __webpack_public_path__ + "static/media/24UHCHR5.3bca7e7f.jpg";